export default {
  data() {
    return {
      watchType: null,
      fileUrl: ''
    }
  },
  methods: {
    // 预览点击
    yulan(obg, leixing, isStatistics = true,isClass=false) {// isStatistics:是否计算预览次数，isClass是否三师课堂的视频
      if (isStatistics) { 
        let urlLink = leixing == 1 ? `/server/resource/common/updateVisitedNumber` : `/server/resource/common/updateThematicVisitedNumber`;
        let param = { resourceId: leixing == 1 ? obg.resourceId ? obg.resourceId : obg.id : obg.thematicResourceId ? obg.thematicResourceId : obg.resourceId };
        this.$ajax.post(urlLink, param).then(res => {
          console.log("更新浏览量返回", res);
        })
      }
      console.log(obg);
      if (obg.fileType < 4) {
        this.fileUrl = window.sessionStorage.getItem("previewUrl") + window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
        this.watchType = obg.fileType;
        let routeData = this.$router.resolve({ name: 'preview', params: { watchType: this.watchType, fileUrl: this.fileUrl } }); window.open(routeData.href, '_blank');
      } else if (obg.fileType == 4) {
        this.fileUrl = window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
        this.watchType = obg.fileType
        let routeData = this.$router.resolve({ name: 'preview', params: { watchType: this.watchType, fileUrl: this.fileUrl } }); window.open(routeData.href, '_blank');
      } else if (obg.fileType == 5) {
        this.fileUrl = isClass?window.sessionStorage.getItem("fileJavaServerUrl") + obg.fileUrl:window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
        this.watchType = obg.fileType
        let routeData = this.$router.resolve({ name: 'preview', params: { watchType: this.watchType, fileUrl: this.fileUrl } }); window.open(routeData.href, '_blank');
      } else {

      }
    },
    // 获取子节点返回的查看值
    getWatchType(event) {
      console.log(event);
      this.watchType = event;
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/yulan.js